import { Component } from '@angular/core';

import { MessagesService } from './messages.service';
import { MessageModel }    from './typings/message';

@Component({
  host: {
    class: 'ngb-toasts'
  },
  selector   : 'wor-messages',
  styles: [ require('./messages.component.scss') ],
  template: require('./messages.component.html')
})
export class MessagesComponent {
  constructor (
    public messagesService  : MessagesService
  ) {}

  close ( message : MessageModel ) {
    this.messagesService.remove(message);
  }

  getClass ( message : MessageModel ) : string {
    switch (message.type) {
      case 'error':
        return 'bg-danger';
      case 'info':
        return 'bg-info';
      case 'warning':
        return 'bg-warning';
      case 'success':
      default:
        return 'bg-success';
    };
  }

  getIcon ( message : MessageModel ) : string {
    switch (message.type) {
      case 'error':
        return 'ban';
      case 'info':
        return 'info-circle';
      case 'warning':
        return 'exclamation-triangle';
      case 'success':
      default:
        return 'check-circle';
    };
  }
}
